import { PaymentOption, RevenueCustomerType } from '@navio/nsdk';
import { useNoddiQueryParam } from 'noddi-ui-web';
import { BooleanParam, createEnumParam, NumberParam, withDefault } from 'use-query-params';

import { REVENUE_COMPARISONS, REVENUE_RANGES, type RevenueComparison, type RevenueRange } from './revenuePeriod';
import type { RevenueFilters, RevenueSplit } from './revenueTotals';

const rangeParam = createEnumParam<RevenueRange>([...REVENUE_RANGES]);
const comparisonParam = createEnumParam<RevenueComparison>([...REVENUE_COMPARISONS]);
const splitParam = createEnumParam<RevenueSplit>(['status', 'method', 'type', 'service']);
const paymentOptionParam = createEnumParam<PaymentOption>(Object.values(PaymentOption));
const customerTypeParam = createEnumParam<RevenueCustomerType>(Object.values(RevenueCustomerType));

/** Shareable view state. Only `range` and `comparison` change the request; the rest filters the loaded data. */
export const useRevenueFilters = () => {
  const [range, setRange] = useNoddiQueryParam('range', withDefault(rangeParam, '30d'));
  const [comparison, setComparison] = useNoddiQueryParam('comparison', withDefault(comparisonParam, 'previous'));
  const [split, setSplit] = useNoddiQueryParam('split-by', withDefault(splitParam, 'status'));
  const [includeUpcoming, setIncludeUpcoming] = useNoddiQueryParam('include-upcoming', withDefault(BooleanParam, true));
  const [paymentOption, setPaymentOption] = useNoddiQueryParam('payment-option', paymentOptionParam);
  const [customerType, setCustomerType] = useNoddiQueryParam('customer-type', customerTypeParam);
  const [serviceCategoryId, setServiceCategoryId] = useNoddiQueryParam('service-category', NumberParam);
  const filters: RevenueFilters = {
    paymentOption: paymentOption ?? null,
    customerType: customerType ?? null,
    serviceCategoryId: serviceCategoryId ?? null
  };
  return {
    range: range ?? '30d',
    setRange,
    comparison: comparison ?? 'previous',
    setComparison,
    split: split ?? 'status',
    setSplit,
    includeUpcoming: includeUpcoming ?? true,
    setIncludeUpcoming,
    filters,
    setPaymentOption,
    setCustomerType,
    setServiceCategoryId
  };
};
